module.exports = __webpack_public_path__ + "static/personal_wealth_spectrum-7bf0042b98c5b4707a7e966eddb7ca52.png";